import React from "react";
import { IOSSec } from "./ios";

export const IOS = () => {
  return (
    <React.Fragment>
      <div className="ios-main">
        <IOSSec />
      </div>
    </React.Fragment>
  );
};
